import { Injectable } from '@angular/core';
import {AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument} from 'angularfire2/firestore';
import {Observable} from 'rxjs/Observable';
import {Scooters, ScootersData, Devices} from '../pages/layout/list-scooters/list-scooters.component';
import {BatteriesData} from '../pages/layout/list-batteries/list-batteries.component';
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import 'rxjs/add/operator/map';


@Injectable({
  providedIn: 'root'
})
export class ScootersService {

  constructor(private afs: AngularFirestore) {
   }

  getScooters(){
    return this.afs.collection<Scooters>(environment.env.EnvBaseUrl+'/'+environment.env.ScootersCollection).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as Scooters;
        const id = action.payload.doc.id;
        return { id, ...data };
      });
    });;
  } 

  getScooterData(uid){
    return this.afs.doc(environment.env.EnvBaseUrl+'/'+environment.env.ScootersCollection+'/'+uid).snapshotChanges().pipe(map(action => {
        const data = action.payload.data() as ScootersData;
        const id = action.payload.id;
        return { id, ...data };
    })
    );
  } 

  getBatteriesData(IMEI){
      // console.log(IMEI);
    return this.afs.doc('/devices/'+IMEI+'/SwapStn/Status').snapshotChanges().pipe(map(action => {
        const data = action.payload.data() as BatteriesData;
        const id = action.payload.id;
        return { id, ...data };
    })
    );
  }

//   getAllSwapstationStatus(imeiArr){
//     // console.log(IMEI);
//     var dict = {};
//     imeiArr.forEach(element => {
//       return this.afs.doc('/devices/'+element+'/SwapStn/Status').snapshotChanges().pipe(map(action => {
//         const data = action.payload.data() as BatteriesData;
//         const id = action.payload.id;
//         console.log('hersdfs'+data['online'])
//         dict[element]=data['online']
//         return dict;
//     })
//     );
//   });
// }

  getChargerStatus(IMEI) {
    return this.afs.doc('/devices/'+IMEI).snapshotChanges().pipe(map(action => {
      const data = action.payload.data() as BatteriesData;
      const id = action.payload.id;
      return { id, ...data };
    })
    );
  }

  getDoorsData(IMEI,door_no){
    return this.afs.doc('/devices/'+IMEI+'/Batteries/'+door_no).snapshotChanges().pipe(map(action => {
        const data = action.payload.data() as BatteriesData;
        const id = action.payload.id;
        return { id, ...data };
    })
    );
  }

  getDeviceData(){
    return this.afs.collection<Devices>(environment.env.EnvBaseUrl+'/'+environment.env.DevicesCollection).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as Devices;
        const id = action.payload.doc.id;
        let charge = "No Info";
        if (data['state'] && data['state']['bms_param']) {
          charge = data['state']['bms_param'].rsoc + "%";
        }
        return { id, ...data, 'batteryCharge': charge };
        // if (data['DeviceType']!='' && data['DeviceType']!=undefined ) {
        //   return { id, ...data, 'batteryCharge': charge };
        // }
      });
    });
  }

  getDeviceDataForScooter(ScooterId) {
    return this.afs.collection<Scooters>(environment.env.EnvBaseUrl+'/'+environment.env.DevicesCollection, ref =>
    ref.where('ScooterId', '==',ScooterId)).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as Scooters;
        const id = action.payload.doc.id;
        let charge = "No Info";
        if (data['state'] && data['state']['bms_param']) {
          charge = data['state']['bms_param'].rsoc + "%";
        }
        if(data.hasOwnProperty('state') && data['state'].hasOwnProperty('status')) {
          if(data['state']['status'] == 0) {
            data['state']['status'] = 'OFF';
          } else if (data['state']['status'] == 1) {
            data['state']['status'] = 'ON';
          } else if(data['state']['status'] == 2) {
            data['state']['status'] = 'EMERGENCY';
          } else { }
         }
        return { id, ...data, 'batteryCharge': charge };
      });
    });
  }

  getScootersData(uid){
    return this.afs.doc(environment.env.EnvBaseUrl+'/'+environment.env.ScootersCollection+'/'+uid).snapshotChanges().pipe(map(action => {
        const data = action.payload.data() as Scooters;
        const id = action.payload.id;
        return { id, ...data };
    })
    );
  }

  getScooterByUser(username){
    return this.afs.collection<Scooters>(environment.env.EnvBaseUrl+'/'+environment.env.ScootersCollection, ref =>
    ref.where('UserID', '==',username)).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as Scooters;
        const id = action.payload.doc.id;
        return { id, ...data };
      });
    });;  

  }

  getScooterByBattery(batteryId) {
    return this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.ScootersCollection, ref =>
    ref.where('BatteryID', '==',batteryId)).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data();
        const id = action.payload.doc.id;
        return { id, ...data };
      });
    });
  }

  getUnoccupiedScooters() {
    return this.afs.collection<Scooters>(environment.env.EnvBaseUrl+'/'+environment.env.ScootersCollection, ref =>
    ref.where('UserID', '==',"")).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as Scooters;
        const id = action.payload.doc.id;
        return { id, ...data };
      });
    });
  }

  editScooter(data,id){
    return new Promise<any>((resolve, reject) =>{
      this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.ScootersCollection).doc(id).update(data).then(res => {}, err => reject(err));
  });
  
  }

  addScooter(data){
    data.RiderObj = {Name:'N/A'};
    data.BatteryObj = {};
    return new Promise<any>((resolve, reject) =>{
      this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.ScootersCollection).add(data).then(res => {
        this.editScooter({id: res.id, ...data}, res.id).then(res=>{});
        this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.DevicesCollection).doc(data.IMEI).set({"ScooterId":res.id},{merge:true});
        this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.RulesCollection).doc(res.id).set({});
        resolve(res);
      }, err => reject(err));
  });
  }

  deleteScooter(scooter) {
    return this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.ScootersCollection).doc(scooter.id).delete();
  }
  
//The Below two function are old function which were earlier used inside swapstation details to updateSwapstationDoor and Charger  goto swapstation service to see newer functions
  updateSwapStnDoor(door_array, door_no, powerheive, IMEI) {
    //NOTE-NUMBER OF DOORS IN POWERHIVE AND BATTERYPOOL SWAPSTATION ARE DIFFERENT THEREFORE door_array is initialized in if else
    if(powerheive===true) {
      door_array=[0,0,0,0,0,0,0,0,0,0,0,0]
    door_array[door_no-1] = 1;
    } else {
      door_array=[0,0,0,0,0,0]
      door_array[door_no-1] = 1;
    }
    this.afs.doc(`/devices/${IMEI}`).update({'state.door_status':door_array});
  }

  updateChargerStatus(chargerStatusList, door_no, IMEI) {
    if(chargerStatusList[door_no-1] == 0){
      chargerStatusList[door_no-1] = 1;
    } else {
      chargerStatusList[door_no-1] = 0;
    }
    this.afs.collection('devices').doc(IMEI).update({'state.charger_status': chargerStatusList});
  }

  updateChargerStatusList(chargerStatusList) {
    console.log("list: ", chargerStatusList);
    this.afs.collection('devices').doc('868325029814001').update({'state.charger_status': chargerStatusList});
  }

  // NOTE: commented code is for traccar api implementations
  // getTraccarDevices() {
  //   return this.afs.collection<Devices>(environment.env.EnvBaseUrl+'/'+environment.env.TraccarDevicesCollection).snapshotChanges().map(actions => {
  //     return actions.map(action => {
  //       const data = action.payload.doc.data() as Devices;
  //       const id = action.payload.doc.id;
  //       let charge = "No Info";
  //       return {...data};
  //       // if (data['state'] && data['state']['bms_param']) {
  //       //   charge = data['state']['bms_param'].rsoc + "%";
  //       // }
  //       // return { id, ...data, 'batteryCharge': charge };
  //     });
  //   });
  // }

  // getTraccarPositions() {
  //   return this.afs.collection(environment.env.EnvBaseUrl+'/'+environment.env.TraccarDevicesPositionCollection).snapshotChanges().map(actions => {
  //     return actions.map(action => {
  //       const data = action.payload.doc.data();
  //       const id = action.payload.doc.id;
  //       return {...data, ...data['attributes']};
  //       // if (data['state'] && data['state']['bms_param']) {
  //       //   charge = data['state']['bms_param'].rsoc + "%";
  //       // }
  //       // return { id, ...data, 'batteryCharge': charge };
  //     });
  //   });
  // }

}
